/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { useTranslate } from '@im/react-localization';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import LabeledField from 'src/components/Form/LabeledField';
import SelectSearchInputField from 'src/views/pricing/Approvals/ManageApproversTab/forms/fields/SelectSearchInputField';
import AttributeValue from './AttributeValue';
import {
  ProgramAttribute,
  ProgramAttributesType,
} from '../../hooks/rule-submit';
import { useProgramAttributesSearchQuery } from '../../hooks/singlePricingSearch';

const MAX_NUM_ATTRS = 3;
type ProgramAttributesComponentType = {
  onChange: (v: ProgramAttributesType) => void;
  program: any;
};
type VendorCode = {
  label: string;
  value: string;
};
const ProgramAttributes = ({
  onChange,
  program,
}: ProgramAttributesComponentType) => {
  const translate = useTranslate();
  const [vendorCode, setVendorCode] = useState<VendorCode>({
    label: '',
    value: '',
  });
  const [attributes, setAttributes] = useState<ProgramAttribute[]>([
    { attributeName: '', attributeValue: '', id: -1, itemId: uuidV4() },
  ]);
  const handleOnVendorCodeInputChange = (event: any, item: any) => {};
  const { data: { list } = {}, isLoading } = useProgramAttributesSearchQuery(
    program?.id
  );
  const handleOnAttributesChange = (_: any, item: any) => {
    const _attributes = attributes.map((attribute: ProgramAttribute) =>
      attribute.itemId !== item.itemId ? attribute : item
    );
    setAttributes(_attributes);
    onChange({
      attributes: _attributes.filter(
        (attr) => attr.attributeName && attr.attributeValue
      ),
      vendorCode: vendorCode.value,
    });
  };
  const handleOnVendorCodeChange = (_: any, vc: VendorCode) => {
    setVendorCode(vc);
    onChange({
      attributes: attributes,
      vendorCode: vc.value,
    });
  };
  const handleRemove = (item: ProgramAttribute) => {
    setAttributes(
      attributes.filter((attribute) => item.itemId !== attribute.itemId)
    );
  };
  const handleAdd = () => {
    setAttributes([
      ...attributes,
      { attributeName: '', attributeValue: '', id: -1, itemId: uuidV4() },
    ]);
  };
  const vendorCodes = [1, 2, 3, 4, 5].map((i) => ({
    label: `VC0${i} - Test vendor code ${i}`,
    value: `vc0${i}`,
  }));
  return (
    <>
      <Box width={512}>
        <LabeledField label={translate('Pricing.VendorCodeOptional')}>
          <SelectSearchInputField
            isLoading={false}
            onChange={handleOnVendorCodeChange}
            onInputChange={handleOnVendorCodeInputChange}
            options={vendorCodes}
            value={vendorCode}
          />
        </LabeledField>
      </Box>
      {program?.id &&
        attributes.map((attr, index) => (
          <Stack
            alignItems={'center'}
            direction="row"
            gap={2}
            key={attr.itemId}
          >
            <AttributeValue
              initialData={attr}
              isLoading={isLoading}
              onChange={handleOnAttributesChange}
              programAttrs={list}
              selectedAttrs={attributes.map(
                (attr: any) => `${attr.attributeName}-${attr.attributeValue}`
              )}
            />
            {attributes.length > 1 && (
              <Button
                onClick={() => handleRemove(attr)}
                sx={{
                  alignSelf: 'end',
                  marginBottom: '4px',
                  minWidth: 0,
                  padding: '6px',
                }}
              >
                <DeleteOutlinedIcon
                  fontSize="small"
                  sx={{ color: '#646464 !important' }}
                />
              </Button>
            )}
            {attributes.length < MAX_NUM_ATTRS &&
              index === attributes.length - 1 && (
                <Button
                  onClick={handleAdd}
                  sx={{
                    alignSelf: 'end',
                    marginBottom: '4px',
                    minWidth: 0,
                    padding: '6px',
                  }}
                >
                  <AddIcon
                    fontSize="small"
                    sx={{ color: '#646464 !important' }}
                  />
                </Button>
              )}
          </Stack>
        ))}
    </>
  );
};
export default ProgramAttributes;
